import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { observer } from "mobx-react";
import React, { lazy, Suspense } from "react";
var LazyImpl = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "header-categories-dropdown" */ "@faire/retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/__internal__/Dropdown/Dropdowns").then(function(m) {
        return {
            default: m.Dropdowns
        };
    });
});
var LazyDropdownsBase = function(props) {
    if (isPrerender() || props.selectedLinkName) {
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyImpl, _object_spread({}, props))
        });
    }
    return null;
};
export var LazyDropdowns = observer(LazyDropdownsBase);
